import React from "react";
import { Link } from "react-router-dom";

const SUPPORT_EMAIL = "beckettseb367@gmail.com";

export default function SiteFooter() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <img src="/brand-icon.png" alt="AutoGridSocial" className="h-8 w-8 rounded-lg" />
            <span className="font-display font-bold">AutoGridSocial</span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
            <Link to="/blog" data-testid="footer-link-blog" className="text-muted-foreground hover:text-foreground transition-colors">Guides</Link>
            <Link to="/start" data-testid="footer-link-start" className="text-muted-foreground hover:text-foreground transition-colors">Get started free</Link>
            <Link to="/#live-preview" data-testid="footer-link-tools" className="text-muted-foreground hover:text-foreground transition-colors">Scan your website</Link>
            <Link to="/affiliates" data-testid="footer-link-affiliates" className="text-muted-foreground hover:text-foreground transition-colors">Affiliates</Link>
            <Link to="/security" data-testid="footer-link-security" className="text-muted-foreground hover:text-foreground transition-colors">Security</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/refunds" data-testid="footer-link-refunds" className="text-muted-foreground hover:text-foreground transition-colors">Refunds &amp; Cancellation</Link>
            <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-support-email" className="text-muted-foreground hover:text-foreground transition-colors">Support</a>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-border space-y-2">
          <p className="text-xs text-muted-foreground" data-testid="footer-billing-note">
            Plans from $29/mo, starting with a $1 7-day trial. Cancel anytime with 1 click.
          </p>
          <p className="text-xs text-muted-foreground" data-testid="footer-copyright">
            © 2026 AutoGridSocial. All rights reserved. Operated by Beckett LLC.
            {" "}Support: <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-foreground">{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
